
export default {
  props: {
    className: {
      type: String,
      default: 'u-app-img'
    },
    src: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 50
    },
    height: {
      type: Number,
      default: 50
    },
    fixed: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String,
      default: 'data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQImWNgYGBgAAAABQABh6FO1AAAAABJRU5ErkJggg=='
    }
  },
  data: function data() {
    return {
      imgUrl: '',
      loading: true,
      loadingClass: '',
      imgWidth: 'auto',
      imgHeight: 'auto'
    };
  },

  watch: {
    src: function src() {
      this.lazyload();
    }
  },
  mounted: function mounted() {
    this.lazyload();
    if (this.fixed !== 1) {
      this.loadingClass = 's-loading-w' + this.width;
    }
  },

  methods: {
    lazyload: function lazyload() {
      var self = this;
      self.loading = true;
      self.imgUrl = self.placeholder;
      var img = new Image();
      img.src = self.src;
      img.onload = function () {
        self.imgUrl = self.src;
        self.loading = false;
        if (img.width >= img.height) {
          self.imgWidth = img.width > self.width ? self.width : img.width;
          self.imgHeight = 'auto';
        } else {
          self.imgWidth = 'auto';
          self.imgHeight = img.height > self.height ? self.height : img.height;
        }
        if (self.fixed === 1) {
          // debugger
          self.imgWidth = self.width;
          self.imgHeight = self.height;
        }

        img = null;
      };
      img.onerror = function () {
        self.loading = false;
        img = null;
      };
    }
  }
};